import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { BrollCaptionVideo } from '../../@types';

interface CaptionProgressParams {
  videoId: string;
}

export const fetchCaptionProgress = async ({
  videoId,
}: CaptionProgressParams): Promise<{ progress: number }> => {
  const response = await axiosInstance.get(`/api/whisper/progress/${videoId}`);
  return response.data;
};

export const useCaptionProgressMutation = () => {
  return useMutation((params: CaptionProgressParams) => fetchCaptionProgress(params));
};
